import { BulkBaseIndexControlDateRange } from "../BulkBaseIndexControl.types";

export function getDateRangeName(dateRange: BulkBaseIndexControlDateRange) {
  switch (dateRange) {
    case BulkBaseIndexControlDateRange.Annual:
      return "Annual";
    case BulkBaseIndexControlDateRange.Quarter:
      return "Quarter";
    case BulkBaseIndexControlDateRange.Month:
      return "Month";
    case BulkBaseIndexControlDateRange.Week:
      return "Week";
    default:
      throw new Error("No name given for date range");
  }
}
